(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      const closeButton = this.querySelector('.announcement__close');
      const ad = window.sessionStorage.getItem('announcementDismissed');

      if (!ad) {
        this.classList.remove('hide');
      }

      if (closeButton) {
        closeButton.addEventListener('click', this.hideAnnouncement.bind(this));
      }
    }

    hideAnnouncement() {
      window.sessionStorage.setItem('announcementDismissed', true);
      this.classList.add('announcement-bar--hide');

      setTimeout(() => {
        this.style.display = 'none';
      }, 300);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-signup-banner"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    class SignupBanner extends HTMLElement {
      constructor() {
        super();

        this.signupForm = this.querySelector('.newsletter-form');

        if (this.signupForm) {
          this.submitButton = this.signupForm.querySelector('button[type="submit"]');

          if (this.submitButton) {
            this.submitButton.removeAttribute('disabled');
          }

          clearInputErrors(this.signupForm);

          this.signupForm.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      handleSubmit(evt) {
        const formIsValid = validateForm(this.signupForm);

        if (formIsValid) {
          if (this.submitButton) {
            this.submitButton.classList.add('btn--loading');
          }
        } else {
          evt.preventDefault();
        }
      }
    }

    customElements.define('signup-banner', SignupBanner);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-linked-menu"]) return;
  try {
    
  class FaqLinkedMenu extends HTMLElement {
    constructor() {
      super();
      this.faqLinkedMenuContent = this.querySelector('.faq-linked-menu-content');
      this.accordionComponent = document.querySelectorAll('.faq-item');
      const faqlinkedItems = [];

      this.accordionComponent.forEach((elm, i) => {
        if (i != 0) {
          elm.classList.add('hide');
        }

        const faqLinkedMenuSection = elm.querySelector('[data-menu-info="faq-linked-menu"]');

        if (faqLinkedMenuSection) {
          const newMenuItem = document.createElement('li');
          newMenuItem.dataset.linkType = elm.dataset.sectionType;
          newMenuItem.innerHTML = faqLinkedMenuSection.innerHTML;

          if (i === 0) {
            newMenuItem.classList.add('active');
          }

          this.faqLinkedMenuContent.appendChild(newMenuItem);

          newMenuItem.addEventListener('click', this.handleClick.bind(this));
        }

        faqLinkedMenuSection.classList.add('hide');
      });
    }

    handleClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const contentId = target.dataset.linkType;

      const activeElement = document.querySelector(`[data-section-type=${contentId}]`);
      const activeHeaderItem = this.faqLinkedMenuContent.querySelector('li.active');

      if (activeHeaderItem !== target) {
        activeHeaderItem.classList.remove('active');
        target.classList.add('active');
      }

      this.accordionComponent.forEach((elm) => {
        if (!elm.classList.contains('hide')) {
          elm.classList.add('collapsible-content--hide');
          setTimeout(function () {
            elm.classList.add('hide');
          }, 200);
        }
      });

      setTimeout(function () {
        activeElement.classList.remove('hide');
        activeElement.classList.remove('collapsible-content--hide');
      }, 200);
    }
  }

  customElements.define('faq-linked-menu', FaqLinkedMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this._topBgRaf = null;
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      if (!this.header) return;

      this.background = this.getAttribute('data-background');
      this.applyColorScheme = this.getAttribute('data-color-scheme');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.headerSearch = this.querySelector('.header__search');

      this.headerHeight = this.header.getBoundingClientRect().height;
      this.headerWrap = this.header.querySelector('.header-wrapper');
      this.isFrosted = this.headerWrap?.dataset?.frosted;
      this.isSticky = this.headerWrap?.dataset?.sticky;
      this.menuInline = this.header.querySelector('.list-menu--inline');
      this.activeMenuItem = this.header.querySelector('.header__active-menu-item');
      this.listMenuItems = this.header.querySelectorAll('.header__inline-menu .list-menu__item-list');

      this.openingMenu = false;
      this.closingMenu = false;
      this.isFadeOutTransition = false;

      this.listMenuItems.forEach((summary) => summary.addEventListener('mouseenter', this.handleMouseEnter.bind(this)));
      this.listMenuItems.forEach((summary) => summary.addEventListener('mouseleave', this.handleMouseleave.bind(this)));
      this.listMenuItems.forEach((summary) => summary.addEventListener('click', this.handleClick.bind(this)));

      // IMPORTANT: detect transparent header (home)
      this.hasTransparentHeader = !!document.querySelector('.shopify-section:first-child [allow-transparent-header]');

      if (this.isSticky) {
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });

        this.createObserver();
      }

      // header height calc
      const searchHomeField = document.getElementById('search-home-field');
      let headerHeight = this.header.getBoundingClientRect().height;
      if (searchHomeField) {
        headerHeight = headerHeight + searchHomeField.getBoundingClientRect().height;
        if (this.hasTransparentHeader) {
          searchHomeField.classList.add('search-home--transparent');
        }
      }
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');

      let prevHeight = 0;
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.contentBoxSize) {
            const height = entry.contentBoxSize?.[0].blockSize;
            if (typeof height === 'number' && height !== prevHeight) {
              prevHeight = height;
              let hh = this.header.getBoundingClientRect().height;
              if (searchHomeField) hh = hh + searchHomeField.getBoundingClientRect().height;
              document.documentElement.style.setProperty('--header-height', hh + 'px');
            }
          }
        }
      });
      resizeObserver.observe(this.header);

      // keep theme behaviour for transparency (home)
      this.setupTransparency();

      // Non-home pages: make sticky immediately (no “hide then show”)
      if (this.isSticky && !this.hasTransparentHeader) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      // initial color
      this.applyTopHeaderColor(window.pageYOffset || document.documentElement.scrollTop);

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', () => {
          this.hasTransparentHeader = !!document.querySelector('.shopify-section:first-child [allow-transparent-header]');
          this.setupTransparency();
          this.applyTopHeaderColor(window.pageYOffset || document.documentElement.scrollTop);
        });
        document.addEventListener('shopify:section:unload', () => {
          this.hasTransparentHeader = !!document.querySelector('.shopify-section:first-child [allow-transparent-header]');
          this.setupTransparency();
          this.applyTopHeaderColor(window.pageYOffset || document.documentElement.scrollTop);
        });
        document.addEventListener('shopify:section:reorder', () => {
          this.hasTransparentHeader = !!document.querySelector('.shopify-section:first-child [allow-transparent-header]');
          this.setupTransparency();
          this.applyTopHeaderColor(window.pageYOffset || document.documentElement.scrollTop);
        });
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this._topBgRaf) cancelAnimationFrame(this._topBgRaf);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // apply color (rAF to reduce flicker)
      if (this._topBgRaf) cancelAnimationFrame(this._topBgRaf);
      this._topBgRaf = requestAnimationFrame(() => this.applyTopHeaderColor(scrollTop));

      // HOME: keep original theme logic (oval, transparency etc.)
      if (this.hasTransparentHeader) {
        if (this.headerSearch && this.headerSearch.isOpen()) return;

        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      // OTHER pages: always sticky, never “hide then show”
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.toggle('scrolled-past-header', scrollTop > 0);

      this.currentScrollTop = scrollTop;
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      if (!this.applyColorScheme) this.header.classList.add(this.background);
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (!this.applyColorScheme) this.header.classList.remove(this.background);
    }

    handleClick(event) {
      const summaryElm = event.target;
      const menuItem = summaryElm.closest('.list-menu__item-list');
      const detailsElement = menuItem?.querySelector('.details--list-menu');
      this.header.classList.add(this.background, 'is-filled');
      setTimeout(() => detailsElement?.classList.add('sub-menu-opening'));
    }

    handleMouseEnter(event) {
      const menuItem = event.target;
      const menuItemSpan = menuItem.querySelector('.header__menu-item');
      const detailsElement = menuItem.querySelector('.details--list-menu');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });
      menuItemSpan?.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.closingMenu && detailsElement.getAttribute('open') && !this.isFadeOutTransition) {
        window.clearTimeout(this.timeoutClose);
        this.closingMenu = false;
      }

      if (detailsElement.getAttribute('open') && !this.isFadeOutTransition) return;

      window.clearTimeout(this.timeoutOpen);
      this.openingMenu = true;

      this.timeoutOpen = setTimeout(() => {
        this.openingMenu = false;
        this.openSubMenu(detailsElement);
      }, 300);
    }

    openSubMenu(detailsElement) {
      detailsElement.setAttribute('open', true);
      if (this.isFrosted) this.headerWrap?.classList.remove('frosted-header-glass');
      this.header.classList.add(this.background, 'is-filled');
      this.closeMenuLocalization();
      setTimeout(() => detailsElement.classList.add('sub-menu-opening'));
    }

    handleMouseleave(event) {
      const menuItem = event.target;
      const detailsElement = menuItem.querySelector('.details--list-menu');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });
      if (this.activeMenuItem) this.activeMenuItem.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.openingMenu && !detailsElement.getAttribute('open')) {
        window.clearTimeout(this.timeoutOpen);
        this.openingMenu = false;
      }

      if (!detailsElement.getAttribute('open')) return;

      this.closingMenu = true;
      this.timeoutClose = setTimeout(() => {
        this.closingMenu = false;
        this.closeSubMenu(detailsElement);
      }, 300);
    }

    closeSubMenu(detailsElement) {
      if (this.isFrosted) this.headerWrap?.classList.add('frosted-header-glass');
      this.header.classList.remove('is-filled');
      if (!this.header.classList.contains('animate')) this.header.classList.remove(this.background);

      detailsElement.classList.remove('sub-menu-opening');
      this.isFadeOutTransition = true;

      detailsElement.addEventListener(
        'transitionend',
        () => {
          detailsElement.removeAttribute('open');
          this.isFadeOutTransition = false;
        },
        { once: true }
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeMenuLocalization() {
      this.headerLocalization = this.headerLocalization || this.header.querySelectorAll('localization-form');
      this.headerLocalization.forEach((disclosure) => disclosure.hidePanel());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    }

    getTopBgFromPath(pathname) {
      const p = (pathname || '').toLowerCase();

      
      const isCollectionOnly = /^\/collections\/[^\/]+\/?$/.test(p);
      if (!isCollectionOnly) return '';

      if (p.includes('mice')) return '#ebf9f4';
      if (p.includes('hamsters') || p.includes('hamster')) return '#fdd3dc';
      if (p.includes('rats') || p.includes('rat')) return '#DEE8AE';
      if (p.includes('gerbils') || p.includes('gerbil') || p.includes('gebrils') || p.includes('gebril')) return '#FAC484';
      return '';
    }


    applyTopHeaderColor(scrollTop) {
      if (!this.header) return;

    
      if (this.hasTransparentHeader) {
        this.header.classList.remove('header--top-colored');
        this.header.style.removeProperty('--header-top-bg');
        return;
      }

      const atTop = (scrollTop || 0) <= 0;
      const color = this.getTopBgFromPath(location.pathname);

      this.header.style.setProperty('--header-top-bg', atTop && color ? color : '');
      this.header.classList.toggle('header--top-colored', atTop && !!color);
    }

    setupTransparency() {
      if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
        this.classList.add(this.background);
        this.setAttribute('data-transparency', true);
      } else {
        if (this.isSticky && !this.applyColorScheme) {
          this.classList.remove(this.background);
        }
        this.removeAttribute('data-transparency');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["made-with"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-made-with]');
  if (!root) return;

  const stage = root.querySelector('[data-stage]');
  const grid = root.querySelector('[data-grid]');
  const detailsWrap = root.querySelector('[data-details]');
  const panels = Array.from(root.querySelectorAll('[data-detail-panel]'));

  if (!stage || !grid || !detailsWrap || !panels.length) return;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mqMobile = window.matchMedia('(max-width: 768px)');
  const isMobile = () => mqMobile.matches;

  const hasGSAP = typeof window.gsap !== 'undefined';
  const enableGSAP = root.getAttribute('data-enable-gsap') === 'true';
  const canAnimate = () => !prefersReduced && hasGSAP && enableGSAP;

  const originalParent = detailsWrap.parentNode;
  const originalNext = detailsWrap.nextSibling;

  const ensureWrapPlacement = () => {
    if (isMobile()) {
      if (detailsWrap.parentNode !== document.body) document.body.appendChild(detailsWrap);
    } else {
      if (detailsWrap.parentNode !== originalParent) {
        if (originalNext) originalParent.insertBefore(detailsWrap, originalNext);
        else originalParent.appendChild(detailsWrap);
      }
    }
  };

  const syncStageHeight = () => {
    if (isMobile()) {
      stage.style.removeProperty('--mw-stage-h');
      return;
    }
    const h = Math.ceil(grid.getBoundingClientRect().height);
    stage.style.setProperty('--mw-stage-h', `${h}px`);
  };

  const hideAllPanels = () => panels.forEach(p => (p.hidden = true));

  // ---- Percent count-up ----
  const parsePercent = (text) => {
    if (!text) return null;
    const n = parseFloat(String(text).replace(',', '.').replace(/[^\d.]/g, ''));
    return Number.isFinite(n) ? n : null;
  };

  const formatPercent = (value, suffix = '%') => {
    const isInt = Math.abs(value - Math.round(value)) < 1e-6;
    return `${isInt ? Math.round(value) : value.toFixed(1)}${suffix}`;
  };

  const countUpNoGSAP = (el, to, duration = 900) => {
    const suffix = (el.getAttribute('data-suffix') || (el.textContent.includes('%') ? '%' : ''));
    const t0 = performance.now();

    const tick = (t) => {
      const p = Math.min(1, (t - t0) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      const v = to * eased;
      el.textContent = formatPercent(v, suffix);
      if (p < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  };

  const animatePercentEl = (el) => {
    if (!el || el.dataset.animated === 'true') return;

    const raw = el.textContent.trim();
    const to = parsePercent(raw);
    if (to === null) return;

    const suffix = raw.includes('%') ? '%' : '';
    el.setAttribute('data-suffix', suffix);
    el.dataset.animated = 'true';

    el.textContent = formatPercent(0, suffix);

    if (canAnimate()) {
      gsap.fromTo(
        el,
        { textContent: 0 },
        {
          textContent: to,
          duration: 0.9,
          ease: 'power2.out',
          onUpdate: () => {
            const v = parseFloat(el.textContent);
            el.textContent = formatPercent(v, suffix);
          }
        }
      );
    } else if (!prefersReduced) {
      countUpNoGSAP(el, to, 900);
    } else {
      el.textContent = formatPercent(to, suffix);
    }
  };

  const observePercents = () => {
    const els = Array.from(root.querySelectorAll('.made-with__percent'));
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(animatePercentEl);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            animatePercentEl(e.target);
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.35 }
    );

    els.forEach((el) => io.observe(el));
  };

  observePercents();

  const setClosedState = () => {
    document.activeElement?.blur(); // щоб не було aria-hidden warning

    hideAllPanels();
    detailsWrap.setAttribute('aria-hidden', 'true');
    detailsWrap.classList.remove('is-active');
    root.classList.remove('is-detail');
    document.body.classList.remove('mw-modal-open');

    ensureWrapPlacement();
    syncStageHeight();
  };

  setClosedState();

  const open = (id) => {
    const panel = panels.find(p => p.getAttribute('data-detail-panel') === id);
    if (!panel) return;

    ensureWrapPlacement();
    hideAllPanels();
    panel.hidden = false;

    // анімувати % всередині detail одразу
    panel.querySelectorAll('.made-with__percent').forEach(animatePercentEl);

    detailsWrap.setAttribute('aria-hidden', 'false');
    detailsWrap.classList.add('is-active');
    root.classList.add('is-detail');
    document.body.classList.add('mw-modal-open');

    syncStageHeight();

    const sheet = panel.querySelector('.made-with__detail-inner');
    if (!sheet) return;

    if (!canAnimate()) {
      sheet.style.opacity = '1';
      sheet.style.transform = 'none';
      sheet.style.visibility = 'visible';
      return;
    }

    gsap.killTweensOf(sheet);

    if (isMobile()) {
      gsap.fromTo(sheet, { autoAlpha: 0, y: 10 }, { autoAlpha: 1, y: 0, duration: 0.25, ease: 'power2.out' });
    } else {
      gsap.set(sheet, { autoAlpha: 0, xPercent: 100 });
      gsap.to(sheet, { autoAlpha: 1, xPercent: 0, duration: 0.6, ease: 'power3.out' });
    }
  };

  const close = () => {
    const panel = panels.find(p => !p.hidden);
    const sheet = panel?.querySelector('.made-with__detail-inner');

    if (!sheet || !canAnimate()) {
      setClosedState();
      return;
    }

    gsap.killTweensOf(sheet);

    if (isMobile()) {
      gsap.to(sheet, { autoAlpha: 0, y: 10, duration: 0.2, ease: 'power2.inOut', onComplete: setClosedState });
    } else {
      gsap.to(sheet, {
        autoAlpha: 0,
        xPercent: 100,
        duration: 0.45,
        ease: 'power3.inOut',
        onComplete: () => {
          gsap.set(sheet, { clearProps: 'all' });
          setClosedState();
        }
      });
    }
  };

  root.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-open-detail]');
    if (!btn) return;
    e.preventDefault();
    open(btn.getAttribute('data-open-detail'));
  });

  detailsWrap.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('[data-close-detail]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      close();
      return;
    }
    if (e.target === detailsWrap) close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root.classList.contains('is-detail')) close();
  });

  window.addEventListener('resize', () => {
    ensureWrapPlacement();
    syncStageHeight();
  });

  window.addEventListener('load', () => {
    ensureWrapPlacement();
    syncStageHeight();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  class newsletterForm extends HTMLElement {
    constructor() {
      super();
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      const sectionId = this.dataset.sectionId;
      const contactNewsletter = this.querySelector(`#Contact_${sectionId}`);
      const inputEmailGroup = contactNewsletter.querySelector('.input-group');
      const inputEmailNewsletter = contactNewsletter.querySelector('input[type="email"]');
      const errorMessage = contactNewsletter.querySelector(`#Newsletter-error--${sectionId}`);
      const errorMessageText = errorMessage.querySelector('.input-error-message__text');
      const iconError = contactNewsletter.querySelector('.field-wrapper__icon-error');
      const existingEmailMsg = contactNewsletter.querySelector('.newsletter-email-exist');
      const urlUserCame = document.referrer ? new URL(document.referrer) : null;

      inputEmailNewsletter.addEventListener('keyup', function (e) {
        if (e.code === 'Enter') return;
        inputEmailGroup.classList.remove('input-group--error');
        inputEmailNewsletter.classList.remove('input--error');
        errorMessage.classList.add('hide');
        iconError.classList.add('hide');
        if (existingEmailMsg) existingEmailMsg.classList.add('hide');
      });

      if (existingEmailMsg && searchParams.has('form_type') && inputEmailNewsletter.value) {
        existingEmailMsg.classList.remove('hide');
      }

      if ( urlUserCame && urlUserCame.pathname === '/challenge' ) {
        document.querySelector(`#Contact_${sectionId}`).scrollIntoView();
      }

      contactNewsletter.addEventListener('submit', (event) => {
        const email = inputEmailNewsletter.value;

        if (!this.validateEmail(email)) {
          event.preventDefault();
          var erroMessage = '';

          if (email === '') {
            erroMessage = window.loginStrings.errorEmailRequired;
          } else {
            erroMessage = window.loginStrings.errorEmailInvalid;
          }

          inputEmailGroup.classList.add('input-group--error');
          inputEmailNewsletter.classList.add('input--error');
          inputEmailNewsletter.setAttribute('aria_invalid', 'true');
          inputEmailNewsletter.setAttribute('aria_describedby', `Newsletter-error--${sectionId}`);
          inputEmailNewsletter.setAttribute('data_form_status', true);

          if (errorMessageText) errorMessageText.textContent = erroMessage;
          errorMessage.classList.remove('hide');
          iconError.classList.remove('hide');
          inputEmailNewsletter.focus();
        }

        return false;
      });
    }

    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }

  customElements.define('newsletter-form', newsletterForm);

  } catch(e) { console.error(e); }
})();
})();
